import { mapActions, mapGetters } from "vuex";
import rulesMixin from '@/mixins/rules.mixin'
import { storeWorkflowId } from '@/utils/workflow.localstorage.util'
import analyticsMixin from "@/mixins/analytics.mixin";
import Recaptcha from "@/components/Recaptcha.vue";

export default {
  mixins: [rulesMixin,analyticsMixin],

  components: {
    Recaptcha
  },

  data: () => ({
    formValid: false,
    email: '',
    password: "",
    showPassword: false,
    verified: false
  }),

  computed: {
    ...mapGetters("profile", ["userInfo","sharedFormId"])
  },

  methods: {
    ...mapActions(["toggleLoadingOverlayStatus"]),

    ...mapActions("profile", ["userSignIn","isSharedUser"]),

    ...mapActions("alert", ["setAlert"]),

    reset() {
      this.email = ""
      this.password = ""
    },

    async logMeIn() {
      if(!this.verified) {
        this.setAlert({ message: "Please complete the reCAPTCHA verification.", type: "error" });
        return false;
      }
      const userAuth = { email: this.email, password: this.password };
      await this.toggleLoadingOverlayStatus(true);
      const { type, message } = await this.userSignIn({ userAuth })
      if(type.toLowerCase() === 'success') {
        localStorage.removeItem('wfid')

        if(this.userInfo.role === 'admin-global') {
          void this.$router.push('/admin')
        } else if(this.userInfo?.is_petitioner === false) {
          if(this.userInfo?.respondent_data?.wfid) {
            void this.$router.push(`/respondent-guide/${this.userInfo.respondent_data.wfid}`)
          } else {
            await this.isSharedUser()
            if(this.sharedFormId) {
              void this.$router.push(`/respondent-guide/${this.sharedFormId}`)
            } else {
              void this.$router.push('/wait')
            }
          }
        } else if(this.userInfo?.forms?.length > 0) {
          void this.$router.push(`/legal-form-guide/divorce-forms/${this.userInfo.forms[0].workflowsUserId}`)
        } else if(this.userInfo?.is_petitioner === true) {
          void this.$router.push('/legal-form-guide')
        } else if(type === 'success') {
          void this.$router.push({ path: '/' })
        }
      } else {
        this.setAlert({ message, type })
      }
      await this.toggleLoadingOverlayStatus(false);
      return false
    },
  },

  mounted() {
    if(this.$route.query?.wfid) {
      storeWorkflowId('wfid', this.$route.query.wfid)
    }

    if(this.$route.query?.email) {
      this.email = this.$route.query.email
    }

    const { type, msg } = this.$route.query
    if(type) {
      this.setAlert({ message: msg, type })
    }
  }
}